// Type-only: keeps `config.ts -> PromoBoxVillage -> PromoBoxElement -> @pub/config`
// from becoming a runtime import cycle.
import type { PromoBoxVariantProps } from "@app/layouts/Article/StorylineElements/PromoBoxElement";
import { Button, Typography } from "@sphtech/dmg-design-system";
import { ReactNode } from "react";

import joinOurVillageTag from "../assets/joinourvillage-tag.png";
import styles from "./promoboxvillage.module.css";

const { SubHeading2, SubHeading4 } = Typography.Heading;

const PromoBoxVillage = ({
  label,
  title,
  ctaLabel,
  ctaUrl,
  children,
}: PromoBoxVariantProps): ReactNode => {
  return (
    <div className={styles.promoBox}>
      {label && (
        <div className={styles.label}>
          <SubHeading4>{label}</SubHeading4>
        </div>
      )}

      <div className={styles.content}>
        <img
          className={styles.tag}
          src={joinOurVillageTag}
          width={100}
          height={100}
          alt="Join our Village"
          loading="lazy"
        />

        <div className={styles.copy}>
          {title && <SubHeading2>{title}</SubHeading2>}

          {children}

          {ctaLabel && ctaUrl && (
            <div className={styles.cta}>
              <Button variant="primary" href={ctaUrl}>
                {ctaLabel}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromoBoxVillage;
